export default __webpack_public_path__ + "static/media/foto9.c16c7813.jpg";